export default "__VITE_ASSET__BcS$ONLf__"